import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/theme/ThemeProvider";
import { AuthProvider } from "@/auth/AuthContext";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { AppShell } from "@/components/layout/AppShell";
import { FunderProvider } from "@/funder/FunderContext";
import { LoginPage } from "@/pages/LoginPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { PlaceholderPage } from "@/pages/PlaceholderPage";
import { ClientsBoardPage } from "@/pages/clients/ClientsBoardPage";
import { ClientOverviewPage } from "@/pages/clients/ClientOverviewPage";
import { MatterFormPage } from "@/pages/clients/MatterFormPage";
import { WorkbenchOverviewPage } from "@/pages/WorkbenchOverviewPage";
import { MatterWorkbenchPage } from "@/pages/MatterWorkbenchPage";
import { QuickTimeLogPage } from "@/pages/QuickTimeLogPage";
import { InvoicesListPage } from "@/pages/InvoicesListPage";
import { InvoiceDetailPage } from "@/pages/InvoiceDetailPage";
import { PaymentsPage } from "@/pages/PaymentsPage";
import { MatterStatementPage } from "@/pages/MatterStatementPage";
import { MatterRecordPage } from "@/pages/MatterRecordPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { ReportsPage } from "@/pages/ReportsPage";
import { YearEndReportPage } from "@/pages/YearEndReportPage";
import WelcomePage from "@/pages/WelcomePage";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/welcome" element={<WelcomePage />} />

            <Route
              element={
                <ProtectedRoute>
                  <FunderProvider>
                    <AppShell />
                  </FunderProvider>
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<DashboardPage />} />
              <Route path="/clients-matters" element={<ClientsBoardPage />} />
              <Route path="/clients-matters/:clientId" element={<ClientOverviewPage />} />
              <Route path="/clients-matters/:clientId/matters/new" element={<MatterFormPage />} />
              <Route path="/matters/:matterId/edit" element={<MatterFormPage />} />
              <Route path="/workbench" element={<WorkbenchOverviewPage />} />
              <Route path="/workbench/:matterId" element={<MatterWorkbenchPage />} />
              <Route path="/matters/:matterId/statement" element={<MatterStatementPage />} />
              <Route path="/matters/:matterId/record" element={<MatterRecordPage />} />
              <Route path="/quick-log" element={<QuickTimeLogPage />} />
              <Route path="/invoices" element={<InvoicesListPage />} />
              <Route path="/invoices/:invoiceId" element={<InvoiceDetailPage />} />
              <Route path="/payments" element={<PaymentsPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/reports/year-end" element={<YearEndReportPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
